import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import AutoFixHighRoundedIcon from "@mui/icons-material/AutoFixHighRounded";
import ConstructionRoundedIcon from "@mui/icons-material/ConstructionRounded";
import QueryStatsRoundedIcon from "@mui/icons-material/QueryStatsRounded";
import SettingsSuggestRoundedIcon from "@mui/icons-material/SettingsSuggestRounded";
import SupportAgentRoundedIcon from "@mui/icons-material/SupportAgentRounded";
import ThumbUpAltRoundedIcon from "@mui/icons-material/ThumbUpAltRounded";
import { useTranslation } from "react-i18next";

export default function Highlights() {
  const { t } = useTranslation();

  const items = [
    {
      icon: <SettingsSuggestRoundedIcon />,
      title: t("adaptable_performance"),
      description: t("adaptable_performance_description"),
    },
    {
      icon: <ConstructionRoundedIcon />,
      title: t("built_to_last"),
      description: t("built_to_last_description"),
    },
    {
      icon: <ThumbUpAltRoundedIcon />,
      title: t("great_user_experience"),
      description: t("great_user_experience_description"),
    },
    {
      icon: <AutoFixHighRoundedIcon />,
      title: t("strong_audience"),
      description: t("strong_audience_description"),
    },
    {
      icon: <SupportAgentRoundedIcon />,
      title: t("social_media_presence"),
      description: t("social_media_presence_description"),
    },
    {
      icon: <QueryStatsRoundedIcon />,
      title: t("precision"),
      description: t("precision_description"),
    },
  ];
  return (
    <Box
      id="highlights"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        color: "white",
        bgcolor: "grey.900",
      }}
    >
      <Container
        sx={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: { xs: 3, sm: 6 },
        }}
      >
        <Box
          sx={{
            width: { sm: "100%", md: "60%" },
            textAlign: { sm: "left", md: "center" },
          }}
        >
          <Typography component="h2" variant="h4" gutterBottom>
            {t("highlights")}
          </Typography>
          <Typography variant="body1" sx={{ color: "grey.400" }}>
            {t("highlights_description")}
          </Typography>
        </Box>
        <Grid container spacing={2}>
          {items.map((item, index) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
              <Stack
                direction="column"
                component={Card}
                spacing={1}
                useFlexGap
                sx={{
                  color: "inherit",
                  p: 3,
                  height: "100%",
                  borderColor: "hsla(220, 25%, 25%, 0.3)",
                  backgroundColor: "grey.800",
                  borderRadius: 4,
                }}
              >
                <Box sx={{ opacity: "50%" }}>{item.icon}</Box>
                <div>
                  <Typography gutterBottom sx={{ fontWeight: "medium" }}>
                    {item.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "grey.400" }}>
                    {item.description}
                  </Typography>
                </div>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
